<span wizHeadTitle i18n>Stage, alternance et emploi par domaine - WIZBII</span>

<section class="contracts">
  <div *ngFor="let contract of contractsCities$ | async; trackBy: trackBySlug" class="contracts__block">
    <a class="contract" [routerLink]="buildTranslatedUrl(contract.slug)">
      {{ contract.title }}
    </a>

    <a
      *ngFor="let contractCities of contract.cityContract; trackBy: trackBySlug"
      [routerLink]="buildTranslatedUrl(contractCities.slug)"
      class="contract contract--city"
    >
      {{ contractCities.title }}
    </a>
  </div>
</section>
